var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupNames(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 7C6.10457 7 7 6.10457 7 5C7 3.89543 6.10457 3 5 3C3.89543 3 3 3.89543 3 5C3 6.10457 3.89543 7 5 7Z",
    fill: "#00000064"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 7C20.1046 7 21 6.10457 21 5C21 3.89543 20.1046 3 19 3C17.8954 3 17 3.89543 17 5C17 6.10457 17.8954 7 19 7Z",
    fill: "#00000064"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 19C21 20.1046 20.1046 21 19 21C17.8954 21 17 20.1046 17 19C17 17.8954 17.8954 17 19 17C20.1046 17 21 17.8954 21 19Z",
    fill: "#00000064"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 21C6.10457 21 7 20.1046 7 19C7 17.8954 6.10457 17 5 17C3.89543 17 3 17.8954 3 19C3 20.1046 3.89543 21 5 21Z",
    fill: "#00000064"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.82929 6C7.93985 5.68722 8 5.35064 8 5C8 4.64936 7.93985 4.31278 7.82929 4H12.5C13.8807 4 15 5.11929 15 6.5V9H17.5C18.8807 9 20 10.1193 20 11.5V16.1707C19.6872 16.0602 19.3506 16 19 16C18.6494 16 18.3128 16.0602 18 16.1707V11.5C18 11.2239 17.7761 11 17.5 11H15V12.5C15 13.8807 13.8807 15 12.5 15H11V17.5C11 17.7761 11.2239 18 11.5 18H16.1707C16.0602 18.3128 16 18.6494 16 19C16 19.3506 16.0602 19.6872 16.1707 20H11.5C10.1193 20 9 18.8807 9 17.5V15H6.5C5.11929 15 4 13.8807 4 12.5V7.82929C4.31278 7.93985 4.64936 8 5 8C5.35064 8 5.68722 7.93985 6 7.82929V12.5C6 12.7761 6.22386 13 6.5 13H9V11.5C9 10.1193 10.1193 9 11.5 9H13V6.5C13 6.22386 12.7761 6 12.5 6H7.82929ZM13 12.5V11H11.5C11.2239 11 11 11.2239 11 11.5V13H12.5C12.7761 13 13 12.7761 13 12.5Z",
    fill: "#00000064"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupNames);
export default __webpack_public_path__ + "static/media/group_names.d41eeeb5fa8769b7b0b53a7fa999db9f.svg";
export { ForwardRef as ReactComponent };